<script lang="ts">
  import {  Col, Container, Row } from "sveltestrap";
  import BookmarkIcoIcons from "./BookmarkIcoIcons.svelte";
  import Card from "../../Core/Card.svelte";
  import icoData from "../../../Data/IconsData/IcoIcon.json"
  import Animalicon from "./Animalicon.svelte";
  import Brandicons from "./Brandicons.svelte";
  import Businessloan from "./Businessloan.svelte";
  import Chartsicon from "./Chartsicon.svelte";
  import Constructionicon from "./Constructionicon.svelte";
  import Currencyico from "./Currencyico.svelte";
  import Device from "./Device.svelte";
  import Directionaliocn from "./Directionaliocn.svelte";
  import Educational from "./Educational.svelte";
  import Emotion from "./Emotion.svelte";
  import Filetypeicon from "./Filetypeicon.svelte";
  import Foodicon from "./Foodicon.svelte";
  import Kidstoysicon from "./Kidstoysicon.svelte";
  import Lawicon from "./Lawicon.svelte";
  import Mathemticaliocn from "./Mathemticaliocn.svelte";
  import Mdicalicon from "./Mdicalicon.svelte";
  import Mobileuiicon from "./Mobileuiicon.svelte";
  import Multimideaiocn from "./Multimideaiocn.svelte";
  import Paymentiocn from "./Paymentiocn.svelte";
  import Personiocn from "./Personiocn.svelte";
  import Searchicon from "./Searchicon.svelte";
  import Socialicon from "./Socialicon.svelte";
  import Sportsicon from "./Sportsicon.svelte";
  import Texteditoricon from "./Texteditoricon.svelte";
  import Traveliocn from "./Traveliocn.svelte";
  import Weatheriocn from "./Weatheriocn.svelte";
  import Webapplication from "./Webapplication.svelte";
  import { AbstractIcons } from "../../../utils/Constant/Constant";
  import {iTag,icons,iconClick} from "../../../store"
  import IconBottom from "../IconBottom.svelte";
  function getItag(tag:any) {
      iTag.update(value => value = `<i class="icofont icofont-${tag}" ></i>`);
      icons.update(value=> value = `icofont icofont-${tag}`) ;
      iconClick.update(value => value = true);
  }
</script>
<BookmarkIcoIcons />
<Container fluid>
    <Row>
      <Col sm="12">
        <Card headerTitle={AbstractIcons} cardHeaderprops="pb-0">
          <div slot="contentbody">
            <Row class="icon-lists">
              {#each icoData[0].abstract as icon}
                <Col sm="6" lg="4">
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <span on:click={() => getItag(icon)}>
                    <i class={`icofont icofont-${icon}`} /> {icon}
                  </span>
                </Col>
              {/each}
            </Row>
          </div>
        </Card>
      </Col>
      <Animalicon />
      <Brandicons />
      <Businessloan />
      <Chartsicon />
      <Constructionicon />
      <Currencyico />
      <Device />
      <Directionaliocn />
      <Educational />
      <Emotion />
      <Filetypeicon />
      <Foodicon />
      <Kidstoysicon />
      <Lawicon />
      <Mathemticaliocn />
      <Mdicalicon />
      <Mobileuiicon />
      <Multimideaiocn />
      <Paymentiocn />
      <Personiocn />
      <Searchicon />
      <Socialicon />
      <Sportsicon />
      <Texteditoricon />
      <Traveliocn />
      <Weatheriocn />
      <Webapplication />
    </Row>
</Container>
<IconBottom />